module.exports = __webpack_public_path__ + "static/media/cardimgfree.1ac6b1a6.png";